import React, { useState } from 'react'
import {
  Box,
  Color,
  Join,
  Space,
} from '@gousto-internal/citrus-react'
import { Link, useParams } from 'react-router-dom'
import type { Section } from '../../types/entities'
import { ContentLoader } from '../ContentLoader'
import { client } from '../../config/routes'
import { createSlugFromUrl } from '../../utils'
import css from './NavigationSections.module.css'

interface NavigationSectionsProps {
  sections: Section[]
}

type NavigationSectionsParams = { sectionId: string }

export const NavigationSections = ({ sections }: NavigationSectionsProps) => {
  const { sectionId } = useParams<NavigationSectionsParams>()
  const [activeSection, setActiveSection] = useState(Number(sectionId))

  if (sections.length === 0) {
    return <ContentLoader />
  }

  return (
    <Box paddingH={10}>
      <Join with={<Space size={2} />}>
        {sections.map((section) => {
          const sectionSlug = createSlugFromUrl(section.htmlURL)
          const url = `${client.categories}/${section.categoryId}${client.sections}/${sectionSlug}/${section.id}`
          const shouldHighlightSection = activeSection === section.id

          return (
            <Link key={section.id} className={css.section} to={url}>
              <Box
                role="button"
                paddingV={3}
                paddingH={2}
                bg={shouldHighlightSection ? Color.NeutralGrey_50 : Color.Transparent}
                onClick={() => setActiveSection(section.id)}
                onKeyDown={() => setActiveSection(section.id)}
              >
                {section.name}
              </Box>
            </Link>
          )
        })}
      </Join>
    </Box>
  )
}
